module.exports = __webpack_public_path__ + "img/ssyx_30.13111df5.jpg";